import styled from 'styled-components';
import Container from '../Container';

export const Root = styled.div`
  overflow-y: auto;
  position: relative;
  top: ${(p) => p.theme.spacing.sm};
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${(p) => p.theme.zIndex.xl};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (min-width: ${(p) => p.theme.screen.md}) {
    align-items: center;
    top: 0;
  }
  & > div {
    padding: ${(p) => p.theme.spacing.lg} ${(p) => p.theme.spacing.xl};
    border-radius: ${(p) => p.theme.radius.default};
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    & > div {
      overflow: auto;
      padding: ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.lg};
    }
  }
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    & > div {
      border-radius: ${(p) => p.theme.radius.none};
      height: fit-content;
      max-height: 100vh;
      padding: ${(p) => p.theme.spacing.xs};
    }
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
  align-items: start;
  text-align: start;
  padding-bottom: ${(p) => p.theme.spacing.none};
  margin-bottom: ${(p) => p.theme.spacing.none};
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  right: 5%;
  top: 10px;
`;
export const ModalContainer = styled(Container)`
  max-height: 95vh;
  overflow-y: auto;
  border-top: 3px solid ${(p) => p.theme.colors.general.black};
  box-shadow: ${(p) => p.theme.shadows.xl};

  h1 {
    font-size: ${(p) => p.theme.font.size.xl};
    line-height: 28px;
  }
`;
